import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Compass } from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { NAV_LINKS } from "@/lib/brand";

const SIDEBAR_ITEMS = [{ id: "top", label: "Start", icon: Compass }];

export default function NotFound() {
  return (
    <PageLayout
      sidebarItems={SIDEBAR_ITEMS}
      title="Seite nicht gefunden"
      testId="not-found-main"
    >
      <section
        id="top"
        data-testid="not-found-section"
        className="relative min-h-[calc(100vh-var(--header-h))] flex items-center pt-32 pb-24 overflow-hidden"
      >
        <div className="pointer-events-none absolute inset-0 -z-10">
          <div className="absolute top-1/4 left-1/3 w-[460px] h-[460px] rounded-full bg-brand-orange/15 blur-[150px] animate-pulseGlow" />
          <div className="absolute bottom-1/4 right-1/3 w-[460px] h-[460px] rounded-full bg-brand-blue/15 blur-[150px] animate-pulseGlow" />
        </div>

        <div className="w-full px-6 md:px-10 lg:px-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="mx-auto max-w-2xl text-center"
          >
            <p className="font-display font-black text-7xl md:text-9xl leading-none gradient-text">
              404
            </p>
            <h1 className="mt-6 font-display font-bold tracking-tight text-3xl md:text-4xl">
              Dieses Tor führt ins Leere.
            </h1>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-white/55">
              Die aufgerufene Seite gibt es nicht - oder nicht mehr. Von hier
              kommt ihr überall hin:
            </p>

            <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="rounded-full border border-white/12 bg-white/[0.03] px-4 py-2 text-sm font-medium text-white/70 hover:text-white hover:border-white/25 hover:bg-white/[0.07] transition-all duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </div>

            <Link
              to="/"
              className="group mt-10 inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-bold text-white bg-gradient-to-r from-brand-orange to-brand-blue shadow-[0_0_35px_-6px_rgba(255,107,0,0.7)] hover:shadow-[0_0_45px_-4px_rgba(0,122,255,0.8)] hover:scale-[1.04] transition-all duration-300"
            >
              <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-300" />
              Zurück zur Startseite
            </Link>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  );
}
